import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { DocumentApi } from '../../../apis/Documents/DocumentApi';
import { Document } from '../Document';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute';

export function useGetDocumentById(id?: string) {
  const documentId = useIdFromRoute() || id;

  return useHighFrequencyRefreshQuery({
    queryKey: [QueryKeys.document, documentId],
    queryFn: async () => {
      const result = await DocumentApi.getDocument(documentId!);
      return new Document(result);
    },
    enabled: !!documentId,
  });
} 